import Vue from 'vue';

// 控制表单控件是否获取焦点
const focus = () => {
  Vue.directive('focus', {
    update(el, { value }) {
      if (value) {
        // 聚焦元素
        el.focus();
      }
    },
  });
};

export default focus;
